import styled from 'styled-components'

const StyledUserContributionItem = styled.div`
        h4 {
            display: inline;
        }

        h4.second {
            margin-left: 30px; 
        }
`;

export default StyledUserContributionItem